import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getKDBuyerCodeDetails,
  getKDChildPartDetails,
  getKDDIReport,
  getKDDITable,
  getKDDeptGraphTable,
  getKDDiLocation,
  getKDDivisionDeptByVendor,
  getKDMTDReport,
  getKDMTDTable,
  getKDParentPartDetails,
  getKDStockReport,
  getKDStockTable,
  getKDVendorDetails,
  getKDVendorGraphTable,
} from "../api/kdStock";

export const fetchKDVendorDetails = createAsyncThunk(
  "kdStock/fetchKDVendorDetails",
  async (params) =>
    getKDVendorDetails(
      params?.division,
      params?.department,
      params?.page,
      params?.search
    ).then((res) => res)
);

export const fetchKDDivisionDeptByVendor = createAsyncThunk(
  "kdStock/fetchKDDivisionDeptByVendor",
  async (params) => getKDDivisionDeptByVendor(params.vendor).then((res) => res)
);

export const fetchKDBuyerCodeDetails = createAsyncThunk(
  "kdStock/fetchKDBuyerCodeDetails",
  async (params) =>
    getKDBuyerCodeDetails(
      params?.division,
      params?.department,
      params?.page,
      params?.search
    ).then((res) => res)
);

export const fetchKDDILocationDetails = createAsyncThunk(
  "kdStock/fetchKDDILocationDetails",
  async () => getKDDiLocation().then((res) => res)
);

export const fetchKDParentPartDetails = createAsyncThunk(
  "kdStock/fetchKDParentPartDetails",
  async (params) =>
    getKDParentPartDetails(
      params?.department,
      params?.vendor,
      params?.division,
      params?.page,
      params?.search
    ).then((res) => res)
);

export const fetchKDChildPartDetails = createAsyncThunk(
  "kdStock/fetchKDChildPartDetails",
  async (params) =>
    getKDChildPartDetails(
      params?.department,
      params?.vendor,
      params?.division,
      params?.page,
      params?.search
    ).then((res) => res)
);

export const fetchKDDeptGraphTable = createAsyncThunk(
  "kdStock/fetchKDDeptGraphTable",
  async (params) =>
    getKDDeptGraphTable(
      params?.division,
      params?.department,
      params?.vendor,
      params?.buyer,
      params?.location,
      params?.parentPart,
      params?.childPart,
      params?.page,
      params?.limit
    ).then((res) => res)
);

export const fetchKDVendorGraphTable = createAsyncThunk(
  "kdStock/fetchKDVendorGraphTable",
  async (params) =>
    getKDVendorGraphTable(
      params?.division,
      params?.department,
      params?.vendor,
      params?.buyer,
      params?.location,
      params?.parentPart,
      params?.childPart,
      params?.page,
      params?.limit
    ).then((res) => res)
);

export const fetchKDStockTable = createAsyncThunk(
  "kdStock/fetchKDStockTable",
  async (params) =>
    getKDStockTable(
      params?.division,
      params?.department,
      params?.vendor,
      params?.buyer,
      params?.location,
      params?.parentPart,
      params?.childPart,
      params?.page,
      params?.limit
    ).then((res) => res)
);

export const fetchKDDITable = createAsyncThunk(
  "kdStock/fetchKDDITable",
  async (params) =>
    getKDDITable(
      params?.parentPartId,
      params?.view,
      params?.month,
      params?.year,
      params?.division,
      params?.department,
      params?.vendor,
      params?.buyer,
      params?.location,
      params?.parentPart,
      params?.childPart,
      params?.page,
      params?.limit
    ).then((res) => res)
);

export const fetchKDMTDTable = createAsyncThunk(
  "kdStock/fetchKDMTDTable",
  async (params) =>
    getKDMTDTable(
      params?.childPartId,
      params?.view,
      params?.month,
      params?.year,
      params?.division,
      params?.department,
      params?.vendor,
      params?.buyer,
      params?.location,
      params?.parentPart,
      params?.childPart,
      params?.page,
      params?.limit
    ).then((res) => res)
);

export const fetchKDStockReport = createAsyncThunk(
  "kdStock/fetchKDStockReport",
  async (params) =>
    getKDStockReport(
      params?.division,
      params?.department,
      params?.vendor,
      params?.buyer,
      params?.location,
      params?.parentPart,
      params?.childPart
    ).then((res) => res)
);

export const fetchKDDIReport = createAsyncThunk(
  "kdStock/fetchKDDIReport",
  async (params) =>
    getKDDIReport(
      params?.parentPartId,
      params?.month,
      params?.year,
      params?.division,
      params?.department,
      params?.vendor,
      params?.buyer,
      params?.location,
      params?.parentPart,
      params?.childPart
    ).then((res) => res)
);

export const fetchKDMTDReport = createAsyncThunk(
  "kdStock/fetchKDMTDReport",
  async (params) =>
    getKDMTDReport(
      params?.childPartId,
      params?.month,
      params?.year,
      params?.division,
      params?.department,
      params?.vendor,
      params?.buyer,
      params?.location,
      params?.parentPart,
      params?.childPart
    ).then((res) => res)
);

export const kdStockSlice = createSlice({
  name: "kdStock",
  initialState: {
    kdVendorDetails: null,
    kdVendorDetailsLoading: false,
    kdDivisionDeptListByVendor: null,
    kdDivisionDetailsLoading: false,
    kdBuyerCodeDetails: null,
    kdBuyerCodeDetailsLoading: false,
    kdDILocationDetails: null,
    kdParentPartDetails: null,
    kdParentPartDetailsLoading: false,
    kdChildPartDetails: null,
    kdChildPartDetailsLoading: false,

    loading: false,
    kdDeptGraphTableDetails: null,
    kdVendorGraphTableDetails: null,
    kDStockTableDetails: null,

    popupLoading: false,
    kdDITableDetails: null,
    kdMTDTableDetails: null,

    kdStockReport: null,
    kdDIReport: null,
    kdMTDReport: null,
  },
  reducers: {
    resetVendorGraphTableDetails: (state, { payload }) => {
      state.kdVendorGraphTableDetails = null;
    },
    resetKdStockTableDetails: (state, { payload }) => {
      state.kDStockTableDetails = null;
    },
  },
  extraReducers: {
    [fetchKDVendorDetails.pending]: (state, { payload }) => {
      state.kdVendorDetailsLoading = true;
    },
    [fetchKDVendorDetails.fulfilled]: (state, { payload }) => {
      state.kdVendorDetails = payload;
      state.kdVendorDetailsLoading = false;
    },
    [fetchKDVendorDetails.rejected]: (state, { payload }) => {
      state.kdVendorDetailsLoading = false;
    },
    [fetchKDDivisionDeptByVendor.pending]: (state, { payload }) => {
      state.kdDivisionDetailsLoading = true;
    },
    [fetchKDDivisionDeptByVendor.fulfilled]: (state, { payload }) => {
      state.kdDivisionDeptListByVendor = payload;
      state.kdDivisionDetailsLoading = false;
    },
    [fetchKDDivisionDeptByVendor.rejected]: (state, { payload }) => {
      state.kdDivisionDetailsLoading = false;
    },
    [fetchKDBuyerCodeDetails.pending]: (state, { payload }) => {
      state.kdBuyerCodeDetailsLoading = true;
    },
    [fetchKDBuyerCodeDetails.fulfilled]: (state, { payload }) => {
      state.kdBuyerCodeDetails = payload;
      state.kdBuyerCodeDetailsLoading = false;
    },
    [fetchKDBuyerCodeDetails.rejected]: (state, { payload }) => {
      state.kdBuyerCodeDetailsLoading = false;
    },
    [fetchKDDILocationDetails.fulfilled]: (state, { payload }) => {
      state.kdDILocationDetails = payload;
    },
    [fetchKDParentPartDetails.pending]: (state, { payload }) => {
      state.kdParentPartDetailsLoading = true;
    },
    [fetchKDParentPartDetails.fulfilled]: (state, { payload }) => {
      state.kdParentPartDetails = payload;
      state.kdParentPartDetailsLoading = false;
    },
    [fetchKDParentPartDetails.rejected]: (state, { payload }) => {
      state.kdParentPartDetailsLoading = false;
    },
    [fetchKDChildPartDetails.pending]: (state, { payload }) => {
      state.kdChildPartDetailsLoading = true;
    },
    [fetchKDChildPartDetails.fulfilled]: (state, { payload }) => {
      state.kdChildPartDetails = payload;
      state.kdChildPartDetailsLoading = false;
    },
    [fetchKDChildPartDetails.rejected]: (state, { payload }) => {
      state.kdChildPartDetailsLoading = false;
    },
    [fetchKDDeptGraphTable.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchKDDeptGraphTable.fulfilled]: (state, { payload }) => {
      state.kdDeptGraphTableDetails = payload;
      state.loading = false;
    },
    [fetchKDDeptGraphTable.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchKDVendorGraphTable.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchKDVendorGraphTable.fulfilled]: (state, { payload }) => {
      state.kdVendorGraphTableDetails = payload;
      state.loading = false;
    },
    [fetchKDVendorGraphTable.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchKDStockTable.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchKDStockTable.fulfilled]: (state, { payload }) => {
      state.kDStockTableDetails = payload;
      state.loading = false;
    },
    [fetchKDStockTable.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchKDDITable.pending]: (state, { payload }) => {
      state.popupLoading = true;
    },
    [fetchKDDITable.fulfilled]: (state, { payload }) => {
      state.kdDITableDetails = payload;
      state.popupLoading = false;
    },
    [fetchKDDITable.rejected]: (state, { payload }) => {
      state.popupLoading = false;
    },
    [fetchKDMTDTable.pending]: (state, { payload }) => {
      state.popupLoading = true;
    },
    [fetchKDMTDTable.fulfilled]: (state, { payload }) => {
      state.kdMTDTableDetails = payload;
      state.popupLoading = false;
    },
    [fetchKDMTDTable.rejected]: (state, { payload }) => {
      state.popupLoading = false;
    },
    [fetchKDStockReport.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchKDStockReport.fulfilled]: (state, { payload }) => {
      state.kdStockReport = payload;
      state.loading = false;
    },
    [fetchKDStockReport.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchKDDIReport.pending]: (state, { payload }) => {
      state.popupLoading = true;
    },
    [fetchKDDIReport.fulfilled]: (state, { payload }) => {
      state.kdDIReport = payload;
      state.popupLoading = false;
    },
    [fetchKDDIReport.rejected]: (state, { payload }) => {
      state.popupLoading = false;
    },
    [fetchKDMTDReport.pending]: (state, { payload }) => {
      state.popupLoading = true;
    },
    [fetchKDMTDReport.fulfilled]: (state, { payload }) => {
      state.kdMTDReport = payload;
      state.popupLoading = false;
    },
    [fetchKDMTDReport.rejected]: (state, { payload }) => {
      state.popupLoading = false;
    },
  },
});

export default kdStockSlice.reducer;
export const { resetVendorGraphTableDetails, resetKdStockTableDetails } =
  kdStockSlice.actions;
